import * as React from "react";
import {generateRoute, goToRoute} from "../../../../utils/Router";
import Th from "../../../../components/table/Th";
import I18nUtils from "../../../../I18n/I18nUtils";
import {OnSortHandler, SortState} from "../../../../utils/Sort";
import DocumentModel from "../../../../model/Document";
import {ROUTE_ADMIN_DOCUMENT_DETAIL} from "../../../../routing/Routes";
import {TR_EXPLOTACION, TR_NOMBRE} from "../../../../I18n/constants";

interface DocumentListTableProps {
    data: DocumentModel[],
    error: string,
    onSort: OnSortHandler,
    sort: SortState,
    renderSelectTd?: (itemId: string) => React.ReactNode,
}

export default class DocumentListTable extends React.Component<DocumentListTableProps> {
    private gotoItemDetail = (itemId: string): void => {
        goToRoute(generateRoute(ROUTE_ADMIN_DOCUMENT_DETAIL, {id: itemId}))
    };

    public render(): React.ReactNode {
        const {data, renderSelectTd} = this.props;

        return (
            <table className="table table-hover">
                <thead>{this.renderTH()}</thead>
                <tfoot>{this.renderTH()}</tfoot>
                <tbody>
                {data && data.map((document: DocumentModel) => {
                    return (
                        <tr key={document.id}
                            onClick={() => this.gotoItemDetail(document.id)}
                            className={"tr-cursor"}
                        >
                            {renderSelectTd ? renderSelectTd(document.id) : null}
                            <td>
                                <a href={document.url} target="_blank" onClick={(event) => event.stopPropagation()}>
                                    {document.name}
                                </a>
                            </td>
                            <td>
                                {document.exploitation ? document.exploitation.name : ''}
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        )
    }

    private renderTH(): React.ReactNode {
        const {sort, onSort, children} = this.props;
        const commonProps = {
            sort,
            onSort,
        };

        return (
            <tr>
                {children}
                <Th text={I18nUtils.tr(TR_NOMBRE)}
                    columnName={'name'}
                    {...commonProps}
                />
                <Th text={I18nUtils.tr(TR_EXPLOTACION)}
                    columnName={'exploitation'}
                    {...commonProps}
                />
            </tr>
        )
    }
}